import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import StaticFieldBack from '../../../../components/StaticField/StaticFieldBack';

class InlineEditBpi extends Component {
    constructor(props) {
        super(props);

        this.onClickGoBack = this.onClickGoBack.bind(this);        
    }
    
    onClickGoBack(event) {
        event.preventDefault();
        
        this.props.history.replace('/Bpi');
    }
    render() {
        let bpi;

        if(this.props.savedBpi.bpi !== undefined && this.props.savedBpi.bpi === true) {
          bpi = "Yes";
        }
        else {
            bpi = "No"
        }
        return (
            <div className="review-inline-edit">
                <StaticFieldBack label='' value={bpi} onClickGoBack={this.onClickGoBack} />                
            </div>);
    }
}

export default withRouter(InlineEditBpi);


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/Bpi/Bpi.js